import { translate } from 'i18n/i18n'
import type { Moment } from 'moment-timezone'

export const formatDateRange = (fromMoment: Moment, toMoment: Moment) => {
  const days = toMoment.diff(fromMoment, 'days')
  const from = translate.dates.format(fromMoment, 'MMM D, YYYY')
  const to = translate.dates.format(toMoment, 'MMM D, YYYY')

  return `${from} to ${to} (${days} days)`
}
